import Decimal from 'decimal.js';
import { isEmpty } from 'lodash';
import {
  ReconDDAGapsQuery,
  ReconDDAGapsResponse
} from '@melio/payments-recon-api-client-ts';
import { useApiRequest } from './useApiRequest';
import { useRecoTableQueryState } from './useRecoTableQueryState';

export function useDDAGaps() {
  const { queryState } = useRecoTableQueryState();

  const body: ReconDDAGapsQuery = {
    from: queryState.from,
    to: queryState.to,
    financialInstitution: queryState.financialInstitution,
    accountType: queryState.accountType
  };

  const {
    data: ddaGaps,
    loading,
    error
  } = useApiRequest<ReconDDAGapsResponse>({
    method: 'post',
    path: '/recon/dda-gaps',
    skip: isEmpty(queryState),
    body,
    cacheKey: isEmpty(queryState)
      ? undefined
      : `dda-gaps:${JSON.stringify(body)}`
  });

  if (!ddaGaps) {
    return { ddaGaps, loading, error };
  }

  const netCredits = new Decimal(ddaGaps.creditsAmount).minus(
    ddaGaps.creditCancellationsAmount
  );

  const netDebits = new Decimal(ddaGaps.debitsAmount).minus(
    ddaGaps.debitCancellationsAmount
  );

  const revenueGap = new Decimal(ddaGaps.revenueAmount).minus(netCredits);
  const expenseGap = new Decimal(ddaGaps.expensesAmount).minus(-netDebits);

  return {
    ddaGaps: {
      credits: {
        amount: ddaGaps.creditsAmount,
        cancellations: ddaGaps.creditCancellationsAmount,
        revenue: ddaGaps.revenueAmount,
        netCredits: netCredits.toNumber(),
        revenueGap: revenueGap.toNumber()
      },
      debits: {
        amount: ddaGaps.debitsAmount,
        cancellations: ddaGaps.debitCancellationsAmount,
        expense: ddaGaps.expensesAmount,
        netDebits: netDebits.toNumber(),
        expenseGap: expenseGap.toNumber()
      }
    },
    loading,
    error
  };
}
